import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Modal, Loader, Input } from 'sa-ui';
import messages from './reportApplicationMessages';
import Field from 'app/common/Field';

import { Formik } from 'formik';

const EditState = {
  PRISTINE: 0,
  PENDING: 1,
  UPDATED: 2,
  ERROR: 3,
};

const ReportApplicationUpdateCriteriaModal = props => {
  function handleFinish(values) {
    props.onFinish(values.criteria);
  }
  function validate(values) {
    const errors = {};
    if (!values.criteria) {
      errors.criteria = props.intl.formatMessage(messages.requiredField);
    }
    if (values.criteria < 0) {
      errors.criteria = props.intl.formatMessage(messages.onlyPositiveValues);
    }
    return errors;
  }

  function getModalStateProps() {
    switch (props.state) {
      case EditState.UPDATED:
        return {
          title: props.intl.formatMessage(messages.updatedSuccessfully),
          icon: 'ti ti-thumb-up',
        };
      case EditState.ERROR:
        return {
          title: props.intl.formatMessage(messages.updateWithError),
          icon: 'ti ti-thumb-down',
        };
      default:
        return {
          title: props.intl.formatMessage(messages.updateEvaluationCriteria),
          icon: 'ti ti-pencil-alt',
        };
    }
  }

  const stateProps = getModalStateProps();

  return (
    <Formik
      validate={validate}
      onSubmit={handleFinish}
      enableReinitialize
      initialValues={{ criteria: props.criteria || '' }}
    >
      {formProps => (
        <Modal
          {...stateProps}
          show={props.show}
          onClose={props.onClose}
          buttons={[
            { onClick: props.onClose, label: props.intl.formatMessage(messages.close) },
            {
              onClick: props.state === EditState.UPDATED ? props.onClose : formProps.handleSubmit,
              disabled: props.state === EditState.PENDING,
              label:
                props.state === EditState.PENDING ? (
                  <Loader simple />
                ) : (
                  props.intl.formatMessage(messages.finish)
                ),
            },
          ]}
        >
          <Field
            name="criteria"
            component={Input}
            label={props.intl.formatMessage(messages.evaluationCriteria)}
            type="number"
            precision="0.01"
            min="0"
          />
        </Modal>
      )}
    </Formik>
  );
};

ReportApplicationUpdateCriteriaModal.propTypes = {};

ReportApplicationUpdateCriteriaModal.defaultProps = {
  state: EditState.PRISTINE,
};

export default injectIntl(ReportApplicationUpdateCriteriaModal);
